// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.message[data-v-e6b4c236], .message-bubble-column[data-v-e6b4c236] {
  flex: 0 0 auto;
}
.message[data-v-e6b4c236], .message-bubble-row[data-v-e6b4c236] {
  max-width: 80vw;
}
.message-bubble[data-v-e6b4c236] {
  border-radius: 18px;
  display: inline-flex;
  font-size: calc(0.95em + 0.25vmin);
  padding: 10px 16px;
  width: -moz-fit-content;
  width: fit-content;
  align-self: center;
  background-color: #f5f8fa !important;
  color: #2c3e50;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12);
  min-width: 60px;
  min-height: 24px;
}
.typing-indicator[data-v-e6b4c236] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.typing-indicator span[data-v-e6b4c236] {
  height: 8px;
  width: 8px;
  margin: 0 2px;
  background-color: #2c3e50;
  border-radius: 50%;
  opacity: 0.4;
  display: inline-block;
  animation: typing-e6b4c236 1.4s infinite ease-in-out both;
}
.typing-indicator span[data-v-e6b4c236]:nth-child(1) {
  animation-delay: 0s;
}
.typing-indicator span[data-v-e6b4c236]:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-indicator span[data-v-e6b4c236]:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes typing-e6b4c236 {
0% {
    transform: scale(1);
}
50% {
    transform: scale(1.5);
    opacity: 0.8;
}
100% {
    transform: scale(1);
    opacity: 0.4;
}
}
.streaming-text[data-v-e6b4c236] {
  margin-left: 8px;
  animation: fadeIn-e6b4c236 0.5s ease-in-out;
}
@keyframes fadeIn-e6b4c236 {
from {
    opacity: 0;
}
to {
    opacity: 1;
}
}
.message-bot .message-bubble[data-v-e6b4c236] {
  background-color: #FFEBEE; /* red-50 from material palette */
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
